function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { z } from 'zod';
import { applicationRequirementTypes } from "../../../types";
import { filterByTypes, updateAggregatedDataCache } from "../../../data/utils";
import { AggregatedData, generateAggregatedDataQueryKey, getAggregatedData, legacyApplicationRequirementTypes, useApplicationId, useApplicationPageAggregatedData, useApplicationPageMutation } from "./aggregatedData";
import { useRef } from 'react';
import { getTraceId, request, useMutation, useQueryClient, useTranslation } from '@applyboard/ui-utils';
import { assert } from "../../../utils/assert";
import { convertArrayToMap } from "../../../utils/convertArrayToMap";
var LegacyRequirementStatus = z.union([z.literal('status_missing'), z.literal('status_reviewing'), z.literal('status_completed'), z.literal('status_not_approved')]);
var DecisionReason = z.object({
  title: z.string(),
  notes: z.string().optional()
});
export var LegacyApplicationRequirementUpdateRequest = z.object({
  data: z.object({
    id: z.string(),
    attributes: z.object({
      status: LegacyRequirementStatus,
      formData: z.record(z.string(), z.unknown()).optional(),
      decisionReasons: z.array(DecisionReason).optional()
    })
  })
});
export function useLegacyApplicationRequirements() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByTypes(data.included, legacyApplicationRequirementTypes);
      }
    }),
    data = _useApplicationPageAg.data;
  if (!data) {
    throw new Error('Legacy application requirements not found in aggregated data.');
  }
  return {
    applicationRequirements: data.map(function (requirement) {
      return _objectSpread({
        id: requirement.id,
        type: requirement.type
      }, requirement.attributes);
    })
  };
}

/**
 * Data mutation hook for updating a requirement via the legacy endpoint
 * Returns aggregated data for the application page
 */
export function useUpdateLegacyApplicationRequirement() {
  var _useApplicationPageMu = useApplicationPageMutation(function (requirement) {
      var requestBody = {
        data: {
          id: requirement.id,
          attributes: {
            status: requirement.status,
            formData: requirement.formData,
            decisionReasons: requirement.decisionReasons
          }
        }
      };
      return {
        url: "/api/application_requirements/".concat(requirement.id).concat(requirement.ignoreFileWarnings ? '?ignore_file_warnings=true' : ''),
        method: 'PATCH',
        body: requestBody
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading;
  return {
    updateApplicationRequirement: mutate,
    isUpdatingApplicationRequirement: isLoading
  };
}
export function useApplicationRequirements(options) {
  var _useApplicationPageAg2 = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByTypes(data.included, applicationRequirementTypes);
      },
      refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval
    }),
    data = _useApplicationPageAg2.data;
  if (!data) {
    throw new Error('Application requirements not found in aggregated data.');
  }
  return {
    applicationRequirements: data.map(function (item) {
      return _objectSpread({
        id: item.id,
        type: item.type
      }, item.attributes);
    })
  };
}
export var IncorrectETagError = /*#__PURE__*/function (_Error) {
  _inherits(IncorrectETagError, _Error);
  var _super = _createSuper(IncorrectETagError);
  function IncorrectETagError(t) {
    _classCallCheck(this, IncorrectETagError);
    return _super.call(this, t('incorrectETagError'));
  }
  return _createClass(IncorrectETagError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * Returns a function called `setNextUpdate` that can be used to "queue" the
 * next requirement update that will be sent to the backend.
 *
 * Note: Calling this function will discard any previous calls that have not
 * started yet, so be sure to include all updates.
 */
export function useUpdateApplicationRequirement() {
  var appId = useApplicationId();
  var queryClient = useQueryClient();
  var _useTranslation = useTranslation('applicationRequirements'),
    t = _useTranslation.t;

  // Used to keep track if the mutation is running.  `status` does not update
  // synchronously so we need to keep track of it ourselves
  var isRunningRef = useRef(false);

  // Used to keep a running record of the permanent file IDs that we have
  // received across various updates.  It's a mapping of temporary file IDs to
  // permanent IDs
  var permanentIdsRef = useRef({});

  // Used to keep track of the next update that will be sent to the backend.
  // The consumer can call `setNextUpdate` to change these values
  var nextUpdateRef = useRef(null);
  var nextUpdateOptionsRef = useRef({});
  var _useMutation = useMutation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _loop;
      return _regeneratorRuntime().wrap(function _callee2$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            isRunningRef.current = true;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var requirement, options, _newRequirement$attri, _newRequirement$attri2, _newRequirement$attri3, existingRequirement, answers, newData, newRequirement, _options$onError, _options$onSuccess;
              return _regeneratorRuntime().wrap(function _loop$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    requirement = nextUpdateRef.current;
                    options = nextUpdateOptionsRef.current;
                    nextUpdateRef.current = null;
                    nextUpdateOptionsRef.current = {};
                    _context2.prev = 4;
                    existingRequirement = getRequirement({
                      id: requirement.id,
                      appId: appId,
                      queryClient: queryClient
                    });
                    assert(existingRequirement);

                    // Before we send the answers to the backend, we need to replace any
                    // temporary IDs with permanent IDs, if we have received the permanent ID
                    // from the backend in the past.  Otherwise the backend will fail.
                    answers = replaceTemporaryIdsWithPermanentIds({
                      answers: requirement.answers,
                      permanentIds: permanentIdsRef.current,
                      formDefinition: existingRequirement.attributes.formDefinition || {
                        components: []
                      }
                    });
                    _context2.next = 10;
                    return request("/api/awa/pages/applications/".concat(appId, "/data/awa/v1/application_requirements/").concat(requirement.id), {
                      method: 'PATCH',
                      schema: AggregatedData,
                      body: {
                        data: {
                          id: requirement.id,
                          type: requirement.type,
                          attributes: {
                            status: requirement.status,
                            answers: answers,
                            deadline: requirement.deadline,
                            flags: requirement.flags
                          }
                        }
                      },
                      allowAnonymous: false,
                      etag: existingRequirement.attributes.etag,
                      throwError: throwErrorIfNeeded(t),
                      getData: function () {
                        var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res, req) {
                          return _regeneratorRuntime().wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return res.json();
                              case 2:
                                _context.t0 = _context.sent;
                                _context.t1 = getTraceId(req);
                                return _context.abrupt("return", {
                                  response: _context.t0,
                                  traceId: _context.t1
                                });
                              case 5:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function getData(_x, _x2) {
                          return _getData.apply(this, arguments);
                        }
                        return getData;
                      }()
                    });
                  case 10:
                    newData = _context2.sent;
                    newRequirement = filterByTypes(newData.response.included, applicationRequirementTypes).find(function (r) {
                      return r.id === requirement.id;
                    });
                    assert(newRequirement);

                    // Update the permanent IDs cache with any permanent IDs we've received.
                    // We need to use the permanent IDs instead of the temporary IDs in
                    // subsequent updates
                    permanentIdsRef.current = updatePermanentIdMapping({
                      permanentIdsMapping: permanentIdsRef.current,
                      sentAnswers: requirement.answers || [],
                      receivedAnswers: ((_newRequirement$attri = newRequirement.attributes.responses) === null || _newRequirement$attri === void 0 ? void 0 : (_newRequirement$attri2 = _newRequirement$attri.answersHistory) === null || _newRequirement$attri2 === void 0 ? void 0 : (_newRequirement$attri3 = _newRequirement$attri2[0]) === null || _newRequirement$attri3 === void 0 ? void 0 : _newRequirement$attri3.answers) || [],
                      formDefinition: existingRequirement.attributes.formDefinition || {
                        components: []
                      }
                    });
                    updateAggregatedDataCache({
                      newData: newData,
                      queryKey: generateAggregatedDataQueryKey(appId),
                      queryClient: queryClient
                    });
                    _context2.next = 24;
                    break;
                  case 17:
                    _context2.prev = 17;
                    _context2.t0 = _context2["catch"](4);
                    nextUpdateRef.current = null;
                    nextUpdateOptionsRef.current = {};
                    isRunningRef.current = false;
                    (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, _context2.t0 instanceof Error ? _context2.t0 : new Error(t('unknownError')));
                    throw _context2.t0;
                  case 24:
                    _context2.prev = 24;
                    (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 ? void 0 : _options$onSuccess.call(options, {
                      permanentIds: permanentIdsRef.current
                    });
                    _context2.next = 34;
                    break;
                  case 28:
                    _context2.prev = 28;
                    _context2.t1 = _context2["catch"](24);
                    nextUpdateRef.current = null;
                    nextUpdateOptionsRef.current = {};
                    isRunningRef.current = false;
                    throw _context2.t1;
                  case 34:
                  case "end":
                    return _context2.stop();
                }
              }, _loop, null, [[4, 17], [24, 28]]);
            });
          case 2:
            if (!nextUpdateRef.current) {
              _context3.next = 6;
              break;
            }
            return _context3.delegateYield(_loop(), "t0", 4);
          case 4:
            _context3.next = 2;
            break;
          case 6:
            isRunningRef.current = false;
            return _context3.abrupt("return", null);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee2);
    }))),
    mutate = _useMutation.mutate,
    status = _useMutation.status;
  return {
    updateStatus: status,
    checkHasMoreUpdates: function checkHasMoreUpdates() {
      return !!nextUpdateRef.current;
    },
    setNextUpdate: function setNextUpdate(updates) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      nextUpdateRef.current = typeof updates === 'function' ? updates(nextUpdateRef.current) : updates;
      nextUpdateOptionsRef.current = options;
      if (!isRunningRef.current) {
        mutate();
      }
    }
  };
}
function throwErrorIfNeeded(t) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
      var data, result;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return res.json();
          case 3:
            data = _context4.sent;
            _context4.next = 9;
            break;
          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            throw new Error(t('unknownError'));
          case 9:
            result = z.object({
              code: z.string(),
              message: z.string()
            }).safeParse(data);
            if (!(result.success && result.data.code === 'precondition_failed' &&
            // See: https://applyboard.slack.com/archives/C06ME2XT59V/p1723640430184749?thread_ts=1723639944.925979&cid=C06ME2XT59V
            result.data.message.includes('etag is not valid'))) {
              _context4.next = 12;
              break;
            }
            throw new IncorrectETagError(t);
          case 12:
            throw new Error(t('unknownError'));
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee3, null, [[0, 6]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/**
 * Gets a requirement object from the aggregated data cache
 */
function getRequirement(_ref3) {
  var id = _ref3.id,
    appId = _ref3.appId,
    queryClient = _ref3.queryClient;
  var aggregatedData = getAggregatedData({
    appId: appId,
    queryClient: queryClient
  });
  var requirements = filterByTypes((aggregatedData === null || aggregatedData === void 0 ? void 0 : aggregatedData.response.included) || [], applicationRequirementTypes);
  return requirements.find(function (r) {
    return r.id === id;
  });
}

/**
 * Given a set of answers, replaces any temporary file IDs with its
 * corresponding permanent file ID, if we have a record of it
 */
function replaceTemporaryIdsWithPermanentIds(_ref4) {
  var answers = _ref4.answers,
    permanentIds = _ref4.permanentIds,
    formDefinition = _ref4.formDefinition;
  if (!answers) {
    return answers;
  }
  var componentsMap = convertArrayToMap(formDefinition.components, 'key');
  return answers.map(function (answer) {
    var component = componentsMap[answer.key];
    if ((component === null || component === void 0 ? void 0 : component.type) === 'file' && Array.isArray(answer.value)) {
      return {
        key: answer.key,
        value: answer.value.map(function (id) {
          return typeof id === 'string' ? permanentIds[id] || id : id;
        }),
        decisions: answer.decisions
      };
    }
    return answer;
  });
}

/**
 * Given the answers sent to the API, and the answers received in the response,
 * updates the mapping of temporary file IDs to permanent file IDs
 *
 * This assumes the order of the files sent in the request is preserved in the
 * response.  This function may throw an error if it detects otherwise
 *
 * @see https://applyboard.slack.com/archives/C06ME2XT59V/p1722010174580159
 */
function updatePermanentIdMapping(_ref5) {
  var permanentIdsMapping = _ref5.permanentIdsMapping,
    sentAnswers = _ref5.sentAnswers,
    receivedAnswers = _ref5.receivedAnswers,
    formDefinition = _ref5.formDefinition;
  var permanentIds = _objectSpread({}, permanentIdsMapping);
  var componentsMap = convertArrayToMap(formDefinition.components, 'key');
  var sentFileAnswers = sentAnswers.filter(function (answer) {
    return componentsMap[answer.key].type === 'file';
  });
  var _iterator = _createForOfIteratorHelper(sentFileAnswers),
    _step;
  try {
    var _loop2 = function _loop2() {
      var _receivedAnswers$find;
      var sentAnswer = _step.value;
      var receivedAnswerValue = ((_receivedAnswers$find = receivedAnswers.find(function (answer) {
        return answer.key === sentAnswer.key;
      })) === null || _receivedAnswers$find === void 0 ? void 0 : _receivedAnswers$find.value) || [];
      assert(Array.isArray(sentAnswer.value) && Array.isArray(receivedAnswerValue), 'Both sent and received answers should be arrays.');
      assert(sentAnswer.value.length === receivedAnswerValue.length, 'Sent answers and received answers should have the same length');
      for (var i = 0; i < sentAnswer.value.length; i++) {
        var sentId = sentAnswer.value[i];
        var receivedId = receivedAnswerValue[i];
        assert(typeof sentId === 'string' && typeof receivedId === 'string');
        if (receivedId !== sentId) {
          assert(!sentAnswer.value.includes(receivedId), 'This permanent ID has already been associated with another temporary ID');
          permanentIds[sentId] = receivedId;
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return permanentIds;
}
export function usePollRequirement(requirementId) {
  var _data$find;
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    enabled = _ref6.enabled;
  var _useApplicationPageAg3 = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByTypes(data.included, legacyApplicationRequirementTypes);
      },
      refetchInterval: 3000,
      enabled: enabled
    }),
    data = _useApplicationPageAg3.data,
    isSuccess = _useApplicationPageAg3.isSuccess;
  return {
    estimatedTimeUntilPrepared: isSuccess ? (_data$find = data.find(function (requirement) {
      return requirement.id === requirementId;
    })) === null || _data$find === void 0 ? void 0 : _data$find.attributes.estimatedTimeUntilPrepared : undefined
  };
}

/**
 * Dispatches a state machine action on an application requirement to the monolith,
 * and returns a copy of the updated application page aggregated data.
 *
 * Note: This hook does not use `useApplicationPageMutation` as a workaround for cases where the
 * updated aggregated data unmounts the component that called the mutation
 * and prevent the onSuccess/onError useMutation callbacks from running.
 * Alternative onSuccess/onError callbacks can be passed as part of the options param
 */
export function useSendRequirementAction() {
  var appId = useApplicationId();
  var queryClient = useQueryClient();
  var _useTranslation2 = useTranslation('applicationRequirements'),
    t = _useTranslation2.t;
  var _useMutation2 = useMutation( /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref7) {
        var action, requirementId, options, existingRequirement, _options$onSuccess2, newData, _options$onError2;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              action = _ref7.action, requirementId = _ref7.requirementId, options = _ref7.options;
              existingRequirement = getRequirement({
                id: requirementId,
                appId: appId,
                queryClient: queryClient
              });
              assert(existingRequirement);
              _context6.prev = 3;
              _context6.next = 6;
              return request("/api/awa/pages/applications/".concat(appId, "/data/awa/v1/application_requirements/").concat(requirementId, "/actions"), {
                method: 'POST',
                schema: AggregatedData,
                body: {
                  data: {
                    type: 'application_requirement_action',
                    attributes: {
                      actionId: action
                    }
                  }
                },
                getData: function () {
                  var _getData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res, req) {
                    return _regeneratorRuntime().wrap(function _callee4$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return res.json();
                        case 2:
                          _context5.t0 = _context5.sent;
                          _context5.t1 = getTraceId(req);
                          return _context5.abrupt("return", {
                            response: _context5.t0,
                            traceId: _context5.t1
                          });
                        case 5:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee4);
                  }));
                  function getData(_x5, _x6) {
                    return _getData2.apply(this, arguments);
                  }
                  return getData;
                }(),
                allowAnonymous: false,
                etag: existingRequirement.attributes.etag,
                throwError: throwErrorIfNeeded(t)
              });
            case 6:
              newData = _context6.sent;
              updateAggregatedDataCache({
                newData: newData,
                queryKey: generateAggregatedDataQueryKey(appId),
                queryClient: queryClient
              });
              options === null || options === void 0 ? void 0 : (_options$onSuccess2 = options.onSuccess) === null || _options$onSuccess2 === void 0 ? void 0 : _options$onSuccess2.call(options);
              _context6.next = 15;
              break;
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](3);
              options === null || options === void 0 ? void 0 : (_options$onError2 = options.onError) === null || _options$onError2 === void 0 ? void 0 : _options$onError2.call(options, _context6.t0 instanceof Error ? _context6.t0 : new Error(t('unknownError')));
              throw _context6.t0;
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee5, null, [[3, 11]]);
      }));
      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }()),
    mutate = _useMutation2.mutate,
    status = _useMutation2.status;
  return {
    sendRequirementAction: mutate,
    sendRequirementActionStatus: status
  };
}
export function useAddApplicationRequirements(appId) {
  var _useApplicationPageMu2 = useApplicationPageMutation(function (requirements) {
      return {
        method: 'POST',
        url: "/applications/".concat(appId, "/requirements/bulk-add"),
        body: {
          data: {
            type: 'bulk_add_application_requirements',
            attributes: {
              requirements: requirements
            }
          }
        }
      };
    }),
    mutate = _useApplicationPageMu2.mutate,
    isLoading = _useApplicationPageMu2.isLoading;
  return {
    addApplicationRequirements: mutate,
    isAddingApplicationRequirements: isLoading
  };
}